<template>

  <v-container fluid>

    <!-- 유튜브 설정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_ytb" @keydown.esc="close_ytb" max-width="500px">
        <v-card class="dialog_round pa-1 pt-4">
          <v-card-text>
            <v-container>
              <v-row dense>
                  <v-text-field v-model="editedItem.YOUTUBE" :label="$t('eventinfo_label1')"></v-text-field>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close_ytb">{{$t("common_cancel")}}</v-btn>
                <v-btn class="dialog_btn" rounded large @click="save_ytb">{{$t("common_ok")}}</v-btn>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>    

    <!-- 이미지 크롭 팝업 (가로) -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_land" @keydown.esc="cancel_crop1" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop1"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_land"
                :img="imgSrc"
                :outputType="option.outputType"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :centerBox="option.centerBox"
                :high="option.high"
                :infoTrue="option.infoTrue"
                :maxImgSize="option.maxImgSize"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :limitMinSize="option.limitMinSize"
                />
            </div>
            <!-- 
            <vue-cropper
                ref="cropper_land"
                :aspectRatio="16/9"
                :src="imgSrc"
                preview=".preview"
                />
            -->
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop1">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- 이미지 크롭 팝업 (세로) -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_port" @keydown.esc="cancel_crop2" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop2"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_port"
                :img="imgSrc2"
                :outputType="option2.outputType"
                :fixed="option2.fixed"
                :fixedNumber="option2.fixedNumber"
                :full="option2.full"
                :canMove="option2.canMove"
                :canMoveBox="option2.canMoveBox"
                :fixedBox="option2.fixedBox"
                :original="option2.original"
                :autoCrop="option2.autoCrop"
                :autoCropWidth="option2.autoCropWidth"
                :autoCropHeight="option2.autoCropHeight"
                :centerBox="option2.centerBox"
                :high="option2.high"
                :infoTrue="option2.infoTrue"
                :maxImgSize="option2.maxImgSize"
                :enlarge="option2.enlarge"
                :mode="option2.mode"
                :limitMinSize="option2.limitMinSize"
                />
            </div>

            <!-- 
            <vue-cropper
                ref="cropper_port"
                :aspectRatio="113/152"
                :src="imgSrc2"
                preview=".preview"
                />
            -->

          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop2">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg2">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row dense no-gutters>
      <v-col md="6" sm="12" xs="12">
        <v-row>
          <v-col cols="12">
            <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
          </v-col>
        </v-row>
        <v-row dense no-gutters align="center">
          <v-col cols="5">
            <v-row dense no-gutters align="center">
              <v-col cols="10">
                <v-text-field 
                  dense single-line clearable
                  @keyup.enter="search_run" 
                  v-model="search_keyword" 
                  :placeholder="$t('common_search_holder')"
                  outlined height="43"
                  color="#808080"
                  hide-details
                  />
              </v-col>
              <v-col cols="2">
                <v-btn class="search_btn mx-1" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
        </v-row>
        
        <v-row>
          <v-col cols="12">
              <!-- 테이블 -->
              <v-data-table
                :headers="headers"
                :items="itemList"
                :no-data-text="$t('common_nodata')"
                hide-default-footer
                class="datatablestyle"
                :items-per-page="pagerow"
                item-key="IDX"
                :loading="loading"
                >
                <template v-slot:[`header.NAME`]>
                  <a :class="sort_name=='NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('NAME')">{{$t("eventinfo_col1")}}</a>
                </template>
                <template v-slot:[`header.STATE_NAME`]>
                  <a :class="sort_name=='STATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE_NAME')">{{$t("eventinfo_col2")}}</a>
                </template>
                <template v-slot:[`header.EVENT_START`]>
                  <a :class="sort_name=='EVENT_START'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_START')">{{$t("eventinfo_col3")}}</a>
                </template>

                <template v-slot:[`item.NAME`]="{ item }">
                    <a  @click="edit_item(item)">{{item.NAME}}</a>
                </template>     
              </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
            <span v-for="n in subpage" :key="n.id">
                <span v-if="page == bottompage-1+n">
                    <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
                </span>
                <span v-else>
                    <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
                </span>
            </span>
            <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
          </v-col>
        </v-row>

      </v-col>

      <v-col cols="12" md="6" sm="12" xs="12" v-if="editedItem.DESC1 != null">

        <v-row>
          <v-col cols="12" align="center">
            <label style="font-size:25px">{{ editedItem.NAME }}</label>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label2')}}</label>
          </v-col>
        </v-row>

        <v-row dense justify="center" style="height:217px">
          <v-col cols="5" style="background:#f6f6f6;height:217px;" class="d-flex align-center">
            <v-img :src="editedItem.IMAGE" height="154" width="274" contain aspect-ratio="1">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0">
                  <div style="height:154px;width:274px; background:#f6f6f6"/>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="5" style="background:#f6f6f6;height:217px;" class="d-flex align-center ml-5">
            <v-img :src="editedItem.IMAGE2" height="185" contain aspect-ratio="1">
              <template v-slot:placeholder>
                <v-row justify="center" class="fill-height ma-0">
                  <div style="height:185px;width:104px;background:#f6f6f6"/>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>        

        <v-row justify="center">
          <v-col cols="5">
            <v-file-input :rules="rules" show-size accept="image/png, image/jpeg" :label="$t('eventinfo_label3')" v-model="uploadFile" @change="change_file"></v-file-input>
          </v-col>
          <v-col cols="5">
            <v-file-input :rules="rules" show-size accept="image/png, image/jpeg" :label="$t('eventinfo_label4')" v-model="uploadFile2" @change="change_file2"></v-file-input>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label5')}}</label>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="10">
            <v-textarea counter="500" color="#4e6ef7" v-model="editedItem.DESC1" :label="$t('eventinfo_label6')" value="" outlined :rules="[ v => (v.length <= 500) || $t('eventinfo_label7') ]" ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label8')}}</label>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="10">
            <v-textarea counter="3000" color="#4e6ef7" v-model="editedItem.DESC2" :label="$t('eventinfo_label6')" value="" outlined :rules="[ v => (v.length <= 3000) || $t('eventinfo_label9') ]"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label10')}}</label>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="10">
            <v-textarea counter="50" color="red" rows="1" outlined v-model="editedItem.HOST" :label="$t('eventinfo_label11')" :rules="[ v  => ( v != null && v.length <= 200) || $t('eventinfo_label12')]"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="10">
            <v-textarea counter="50" color="red" rows="1" outlined v-model="editedItem.ORGANIZER" :label="$t('eventinfo_label13')" :rules="[ v => (v != null &&  v.length <= 200) || $t('eventinfo_label14')]"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label15')}}</label>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="10">
            <v-textarea counter="2000" color="red" outlined v-model="editedItem.INFO" :label="$t('eventinfo_label16')" :rules="[ v => (v != null && v.length <= 2000) || $t('eventinfo_label17')]"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label18')}}</label>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" dense>
          <v-col cols="10" >
            <areadialog :areaname="editedItem.AREANAME" @callback="comareacb"/>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="10">
            <v-text-field ref="addr1" v-model="editedItem.ADDR1" outlined hide-details
            disabled :label="$t('eventinfo_label19')"></v-text-field>
          </v-col>
          <!-- 블루오리진 요청으로 비활성 (직접입력사용안함)
          <v-col cols="2">
            <v-btn class="search_btn" elevation="0" outlined large @click="postcode">주소검색</v-btn>
          </v-col>
          -->
        </v-row>
        <v-row  justify="center">
          <v-col cols="10">
            <v-text-field counter="100" color="red"  ref="addr2" outlined
            v-model="editedItem.ADDR2" :label="$t('eventinfo_label20')" 
            :rules="[ v => ( v != null && v.length <= 100) || $t('eventinfo_label21') ]">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row dense class="mt-0" justify="center">
          <v-col cols="10">
              <div id="gmap" style="width:100%"/>
              <!-- 
              <GmapMap
                ref="mapRef"
                :center="map_position"
                :zoom="16"  map-type-id="roadmap"
                style="width: 500px; height: 300px"
                @click="mapclick"
                >
              </GmapMap>
              -->
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label22')}}</label>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="10">
            <v-text-field v-model="editedItem.LINK_URL" :label="$t('eventinfo_label23')"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label24')}}</label>
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="10">
            <v-row justify="center">
              <v-img :src="youtube_thum" height="167" width="295" contain style="background:#f6f6f6" aspect-ratio="1" @click="play_youtube">
                <template v-slot:placeholder>
                  <v-row justify="center" class="fill-height ma-0">
                    <div style="height:167px;width:295px;background:#f6f6f6"/>
                  </v-row>
                </template>
              </v-img>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-5">
          <v-btn style="background-color:red;color:white" elevation="0" outlined large @click="dialog_ytb = true">{{$t('eventinfo_label25')}}</v-btn>
        </v-row>


        <v-row justify="center" class="mt-5">
          <v-col cols="10">
            <label style="font-size:20px">{{$t('eventinfo_label26')}}</label>
          </v-col>
        </v-row>
        <v-row class="mt-5" justify="center" dense>
          <v-col cols="10">
            <v-select :no-data-text="$t('eventinfo_label27')" outlined hide-details  v-model="editedItem.GALLERY_IDX" :items="GALLIST" :label="$t('eventinfo_label28')" item-text="NAME" item-value="IDX" />
          </v-col>
        </v-row>

        <v-row style="height:50px"></v-row>
        <v-row class="mt-10" justify="center">
          <v-btn rounded style="background-color:#4e6ef7;color:white" width="100" large @click="checks3path">{{$t("common_save")}}</v-btn>
        </v-row>

        <v-row style="height:100px"></v-row>    

      </v-col>

    </v-row>
  
  

  </v-container>
</template>
<script type="text/javascript" src="//dapi.kakao.com/v2/maps/sdk.js?appkey=82fc565ca4c226a9f8b7d9f0b9253275&libraries=services"></script>

<script>

//import VueCropper from 'vue-cropperjs'; //이미지 크롭

import 'cropperjs/dist/cropper.css';
import AWS from 'aws-sdk';  //이건 라이브러리지 컴포넌트가 아니기 대문에 components에는 정의하지 않는다.

import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리


export default {
    components:{
      //draggable,
      VueCropper
    },

    data: () => ({
      gmap:null,
      gmarker:null,

      //이미지 크롭
      crop_dialog_land: false,
      crop_dialog_port: false,
      selectFile:null,
      selectFile2:null,
      imgSrc:'',
      imgSrc2:'',
      ratio: 16/9,
      ratio2: 9/16,
      s3: null,   //aws
      uploadFile : null,
      uploadFile2: null,
      upload_path: null,
      upload_path2: null,

      //파일 사이즈 체크
      rules: [
        value => !value || value.size < 5000000 || $t('eventinfo_msg1'),
      ],

      //신규 크롭 파라메터
      option: {
        img: "",
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixed: true,          //크롭박스 비율 고정
        fixedNumber: [16,9],  //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:400,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:400,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1500,
        limitMinSize: [300, 300]
      },

      option2: {
        img: "",
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixed: true,              //크롭박스 비율 고정
        fixedNumber: [113,152],   //크롭박스 비율
        fixedBox: false,          //true면 크롭박스 크기 조절 안됨
        original: false,          //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:400,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:400,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1500,
        limitMinSize: [300, 300]
      },

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      defaultItem: {
          DESC1:'',
          DESC2:'',
          IMAGE:'',
          YOUTUBE:'',
          LATITUTE:'37.51205332712675',
          LONGITUTE:'127.05914127516714',
          LINK_URL:'',
          ADDR1:'',
          ADDR2:'',
          INFO:'',
          AREANAME:'',
          AREA_IDX : -1,
          GALLERY_IDX:-1,
          IDX:-1,
      },
      editedItem: {},
      

      //테이블 정의
      headers: [
        {text: '행사명', value: 'NAME', sortable: false, align:'center'},
        {text: '상태', value: 'STATE_NAME', sortable: false, align:'center', width:100 },
        {text: '입장 시작일시', value: 'EVENT_START', sortable: false, align:'center', width:180 },
      ],
      itemList: [],

      //검색 파라메터
      search_keyword : '',

      sort_name: 'EVENT_START',
      sort_type: true,    //true : DESC, false: ASC

    //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
      
      //추가파라메터
      GALLIST: [],
      GALIMGLIST: [],
      dialog_ytb : false,
      youtube_thum:'',
      marker_position:{lat: 37.512268, lng: 127.058940},
      map_position: {lat: 37.512268, lng: 127.058940},

      grade : 0,
      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {
      
      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      postcodetoMap(mpos){
        this.map_position    = mpos;
        this.marker_position = mpos;

        this.gmap.panTo(this.map_position);
        this.gmarker.setPosition(this.marker_position);

        //지도위치 저장
        this.save_map();

      },

      postcodetoAddr(addr){

        this.editedItem.ADDR1 = addr;

      },

      //지도
      postcode(){

        //콜백에서 못찾아서 콘스트로 미리 빼둔다.
        const callback_mapfunction      = this.postcodetoMap;
        const callback_addrfunction     = this.postcodetoAddr;

        new daum.Postcode({
            oncomplete: function(data) {

                
                var addr = data.address; // 최종 주소 변수
                if(data.userSelectedType == "J"){
                  //지번
                  addr = data.jibunAddress; 
                }

                //주소 정보를 해당 필드에 넣는다.
                callback_addrfunction(addr);
                
                var geocoder = new kakao.maps.services.Geocoder();
                
                //주소로 상세 정보를 검색
                geocoder.addressSearch(data.address, function(results, status) {

                    // 정상적으로 검색이 완료됐으면
                    if (status === daum.maps.services.Status.OK) {

                        var result = results[0]; //첫번째 결과의 값을 활용

                        // 해당 주소에 대한 좌표를 받아서
                        var coords = new daum.maps.LatLng(result.y, result.x);
                        
                        var markerpos = JSON.parse('{"lat":'+result.y+', "lng":'+result.x+'}');
                        callback_mapfunction(markerpos);

                        //지도를 보여준다.
                        /*
                        mapContainer.style.display = "block";
                        map.relayout();
                        // 지도 중심을 변경한다.
                        map.setCenter(coords);
                        // 마커를 결과값으로 받은 위치로 옮긴다.
                        marker.setPosition(coords)
                        */

                    }
                });
            }
        }).open();

      },


      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
          
          this.editedItem = {};

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/EventListCraw',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){

        //첫페이지 로드
        this.loadpage(1);

      },      

      //검색
      search_run(){
        this.loadpage(1);
      },

      //아이템 수정
      edit_item(item){
        
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.IDX = item.IDX;
        this.editedItem.NAME = item.NAME;

        //여기서 상세 이벤트 페이지 가져오기
        this.loading = true;

        this.$http.post(this.$host+'/api/EventPageDetail',{
              EVENT_IDX: item.IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          this.loading = false;
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              if(list[0].DESC1 == null || list[0].DESC1 == undefined){
                this.$alert(this.$t('eventinfo_msg20')).then(()=>{
                  this.editedItem   = Object.assign({}, this.defaultItem);
                  this.editedItem.IDX = item.IDX;
                  this.editedItem.LATITUTE  = "37.512268";
                  this.editedItem.LONGITUTE = "127.058940";
                  this.editedItem.NAME = item.NAME;
                  this.editedItem.YOUTUBE = "";
                  this.youtube_thum = "";
                  this.map_position    = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
                  this.marker_position = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');

                  if(this.gmap == null){
                    setTimeout(() => {
                      this.gmap = new google.maps.Map(document.getElementById('gmap'), {
                        zoom: 16, center:this.map_position
                      });
                      this.gmarker = new google.maps.Marker({position:this.marker_position});
                      this.gmarker.setMap(this.gmap);
                    }, 300)
                  }else{
                    this.gmap.panTo(this.map_position);
                    this.gmarker.setPosition(this.marker_position);
                  }

                });

              }else{
                
                this.editedItem = list[0];
                this.editedItem.NAME = item.NAME;

                this.setyoutubeimage();
                
                this.map_position    = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
                this.marker_position = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
                
                //맵은 화면에 div가 노출된 후에 그려야한다. 안보이면 오류남.
                if(this.gmap == null){
                  setTimeout(() => {
                    this.gmap = new google.maps.Map(document.getElementById('gmap'), {
                      zoom: 16, center:this.map_position
                    });
                    this.gmarker = new google.maps.Marker({position:this.marker_position});
                    this.gmarker.setMap(this.gmap);
                  }, 300)
                }else{
                  this.gmap.panTo(this.map_position);
                  this.gmarker.setPosition(this.marker_position);
                }
                
              }
              

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
        });
        
        this.gallerylist();

      },

      close_ytb(){
        this.dialog_ytb = false;
      },

      setyoutubeimage(){

        if(this.editedItem.YOUTUBE.startsWith("https://youtu.be/")){
          const strs = this.editedItem.YOUTUBE.split("/");
          const youtube_key = strs[strs.length-1];
          this.youtube_thum = "https://i.ytimg.com/vi/"+youtube_key+"/hqdefault.jpg";

        }else if(this.editedItem.YOUTUBE.startsWith("https://www.youtube.com/watch")){
          const youtube_key = this.getParam(this.editedItem.YOUTUBE, "v");
          this.youtube_thum = "https://i.ytimg.com/vi/"+youtube_key+"/hqdefault.jpg";

        }else{
          this.youtube_thum = "";
        }

      },

      save_ytb(){

        if(this.editedItem.YOUTUBE  == undefined || this.editedItem.YOUTUBE.length < 1){
          this.$alert(this.$t('eventinfo_msg2'));
          return;
        } 

        if(this.editedItem.YOUTUBE.startsWith("https://youtu.be/")){
          const strs = this.editedItem.YOUTUBE.split("/");
          const youtube_key = strs[strs.length-1];
          this.youtube_thum = "https://i.ytimg.com/vi/"+youtube_key+"/hqdefault.jpg";

        }else if(this.editedItem.YOUTUBE.startsWith("https://www.youtube.com/watch")){
          const youtube_key = this.getParam(this.editedItem.YOUTUBE, "v");
          this.youtube_thum = "https://i.ytimg.com/vi/"+youtube_key+"/hqdefault.jpg";

        }else{
          this.$alert(this.$t('eventinfo_msg3'));
        }
        
        this.dialog_ytb = false;

      },

      save_map(){
        
        var temp = JSON.stringify(this.marker_position);
        if(temp == "{}"){
          this.$alert(this.$t('eventinfo_msg4'));
          return;
        }
        const pos = JSON.parse(temp);
        this.editedItem.LATITUTE  =  String(pos.lat);
        this.editedItem.LONGITUTE =  String(pos.lng);
      },


      getParam(url, name) {
        var params = url.substr(url.indexOf("?") + 1);
        var sval = "";
        params = params.split("&");
        var temp = [];
        for (var i = 0; i < params.length; i++) {
          temp = params[i].split("=");
          if ([temp[0]] == name) { sval = temp[1]; }
        }
        return sval;
      },

      play_youtube(){

        if(this.editedItem.YOUTUBE  == undefined || this.editedItem.YOUTUBE.length < 1){
          this.$alert(this.$t('eventinfo_msg5'));
          return;
        } 

        window.open(this.editedItem.YOUTUBE, "_blank");

      },

      change_file(){
        
        //파일명 백업
        this.selectFile = this.uploadFile.name;

        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          //파일이 로드되면
          this.crop_dialog_land = true;       //크롭팝업 띄우고
          this.imgSrc = event.target.result;  //이게 blob데이터
          this.$refs.cropper_land.replace(event.target.result);
        }
        reader.readAsDataURL(this.uploadFile);  //비동기로 파일을 읽어서

      },

      change_file2(){
        
        //파일명 백업
        this.selectFile2 = this.uploadFile2.name;

        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          
          //파일이 로드되면
          this.crop_dialog_port = true;        //크롭팝업 띄우고
          this.imgSrc2 = event.target.result;  //이게 blob데이터
          this.$refs.cropper_port.replace(event.target.result);
        }
        reader.readAsDataURL(this.uploadFile2);  //비동기로 파일을 읽어서

      },



      cancel_crop1(){
        this.uploadFile = null;
        this.selectFile = null;
        this.crop_dialog_land = false;
      },

      cancel_crop2(){
        this.uploadFile2 = null;
        this.selectFile2 = null;
        this.crop_dialog_port = false;
      },
      
      cropimg(){
        //이미지 크롭 
        this.$refs.cropper_land.getCropBlob(blob=>{

          this.crop_dialog_land = false;
          this.uploadFile = blob;

          this.$refs.cropper_land.getCropData(data=>{
            this.editedItem.IMAGE = data; //이미지뷰 미리보기용
          });
          
        });

        /*
        this.$refs.cropper_land.getCroppedCanvas().toBlob(blob =>{
          this.crop_dialog_land = false;
          this.uploadFile = blob;
          this.editedItem.IMAGE = this.$refs.cropper_land.getCroppedCanvas().toDataURL(); //이미지뷰 미리보기용
        })
        */
      },      

      cropimg2(){
        //이미지 크롭 
        this.$refs.cropper_port.getCropBlob(blob=>{
          this.crop_dialog_port = false;
          this.uploadFile2 = blob;
          this.$refs.cropper_port.getCropData(data=>{
            this.editedItem.IMAGE2 = data; //이미지뷰 미리보기용
          });
        });
        /*
        this.$refs.cropper_port.getCroppedCanvas().toBlob(blob =>{
          this.crop_dialog_port = false;
          this.uploadFile2 = blob;
          this.editedItem.IMAGE2 = this.$refs.cropper_port.getCroppedCanvas().toDataURL(); //이미지뷰 미리보기용
        })
        */
      },      

      //s3 폴더 확인 및 업로드
      async checks3path(){

        //저장하기
        if(this.editedItem.DESC1  == undefined || this.editedItem.DESC1.length < 1){
          this.$alert(this.$t('eventinfo_msg6'));
          return;
        } 
        if(this.editedItem.DESC1.length > 500){
          this.$alert(this.$t('eventinfo_msg7'));
          return;
        } 

        if(this.editedItem.DESC2  == undefined || this.editedItem.DESC2.length < 1){
          this.$alert(this.$t('eventinfo_msg8'));
          return;
        } 
        if(this.editedItem.DESC2.length > 3000){
          this.$alert(this.$t('eventinfo_msg9'));
          return;
        } 

        //저장하기
        if(this.editedItem.ADDR1  == undefined || this.editedItem.ADDR1.length < 1){
          this.$alert(this.$t('eventinfo_msg10'));
          return;
        } 
        if(this.editedItem.ADDR1.length > 100){
          this.$alert(this.$t('eventinfo_msg11'));
          return;
        } 
        if(this.editedItem.ADDR2  == undefined || this.editedItem.ADDR2.length < 1){
          this.$alert(this.$t('eventinfo_msg12'));
          return;
        } 
        if(this.editedItem.ADDR2.length > 100){
          this.$alert(this.$t('eventinfo_msg13'));
          return;
        } 
        if(this.editedItem.INFO  == undefined || this.editedItem.INFO.length < 1){
          this.$alert(this.$t('eventinfo_msg14'));
          return;
        } 
        if(this.editedItem.INFO.length > 2000){
          this.$alert(this.$t('eventinfo_msg15'));
          return;
        } 

        const s3obj      = this.$s3;
        const save_img_f = this.event_save;     //콜백함수
        const temp_blob = this.uploadFile;      //크롭된 이미지의 blob데이터
        const temp_url  = this.selectFile;      //크롭전 선택된 이미지 파일명
        const temp_blob2 = this.uploadFile2;      //크롭된 이미지의 blob데이터
        const temp_url2  = this.selectFile2;      //크롭전 선택된 이미지 파일명
        const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
        var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.

        //수정 - 선택된 파일이 없으면 바로 저장
        if( (temp_url == null || temp_url == undefined || temp_url.length < 1) && (temp_url2 == null || temp_url2 == undefined || temp_url2.length < 1) ){
          save_img_f();
          return;
        }

        // s3에 파일 업로드
        // eslint-disable-next-line no-unused-vars
        await s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
          if (err2) {
            //앨범생성 오류
            this.$alert(this.$t('eventinfo_msg16'));
            return;
          }else{
            
          }
        });   

        //앨범생성 성공 - 업로드
        var path1 = "";
        if(temp_url != null && temp_url != undefined && temp_url.length > 0){

          var extens    = temp_url.split(".");
          let extension = extens[extens.length-1];
          var filename = Date.now().toString()+"_land."+extension;       //파일명
          var photoKey = albumPhotosKey + filename;                 //최종 경로
          

          const stored = await s3obj.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: temp_blob,
                                                ACL: "public-read"
                                            }).promise();
          
          
          path1 = stored.Location;
        //   await s3obj.upload({
        //       Bucket: "blueorigin-mice-image",
        //       Key: photoKey,
        //       Body: temp_blob,
        //       ACL: "public-read"
        //   // eslint-disable-next-line no-unused-vars
        //   }, function(err,data){
        //       if(err){
        //         //업로드 실패
        //         this.$alert("오류로 인해 대표이미지를 저장할 수 없습니다.");
        //       }else{
        //         //업로드 성공
        //         if(data.Location != null && data.Location.length > 0){
        //           path1 = data.Location;
        //         }else{
        //           this.$alert("오류로 인해 대표이미지를 저장할 수 없습니다.");
        //         }
        //       }
        //   });
        }

        var path2 = "";
        if(temp_url2 != null && temp_url2 != undefined && temp_url2.length > 0){

          var extens2    = temp_url2.split(".");
          let extension2 = extens2[extens2.length-1];
          var filename2 = Date.now().toString()+"_port."+extension2;       //파일명
          var photoKey2 = albumPhotosKey + filename2;                 //최종 경로
          

          const stored2 = await s3obj.upload({
                                              Bucket: "blueorigin-mice-image",
                                              Key: photoKey2,
                                              Body: temp_blob2,
                                              ACL: "public-read"
                                            }).promise();
          path2 = stored2.Location;
        //   await s3obj.upload({
        //       Bucket: "blueorigin-mice-image",
        //       Key: photoKey2,
        //       Body: temp_blob2,
        //       ACL: "public-read"
        //   // eslint-disable-next-line no-unused-vars
        //   }, function(err,data){
        //       if(err){
        //         //업로드 실패
        //         this.$alert("오류로 인해 세로이미지를 저장할 수 없습니다.");
        //       }else{
        //         //업로드 성공
        //         if(data.Location != null && data.Location.length > 0){
        //           path2 = data.Location;
        //         }else{
        //           this.$alert("오류로 인해 세로이미지를 저장할 수 없습니다...4");
        //         }
        //       }
        //   })
        
        }


        
        save_img_f(path1, path2);

      },

      event_save(upath1, upath2){

        //s3에 업로드된 이미지 url
        this.upload_path1 = upath1;
        this.upload_path2 = upath2;

        this.$http.post(this.$host+'/api/EventPageUpdate',{
            FILEPATH: this.upload_path1 != null ? this.upload_path1 : null
          , FILEPATH2: this.upload_path2 != null ? this.upload_path2 : null
          , EVENT_IDX:  this.editedItem.IDX
          , DESC1:      escape( this.editedItem.DESC1)
          , DESC2:      escape(this.editedItem.DESC2)
          , YOUTUBE:    this.editedItem.YOUTUBE
          , LATITUTE:   this.editedItem.LATITUTE
          , LONGITUTE:  this.editedItem.LONGITUTE
          , LINK_URL:   this.editedItem.LINK_URL
          , GALLERY_IDX:this.editedItem.GALLERY_IDX
          , AREA_IDX:   this.editedItem.AREA_IDX
          , ADDR1:      escape( this.editedItem.ADDR1)
          , ADDR2:      escape(this.editedItem.ADDR2)
          , INFO:      this.editedItem.INFO == null || this.editedItem.INFO == undefined ?  '' : escape(this.editedItem.INFO)
          , HOST:      this.editedItem.HOST == null || this.editedItem.HOST == undefined ?  '' : escape(this.editedItem.HOST)
          , ORGANIZER: this.editedItem.ORGANIZER == null || this.editedItem.ORGANIZER == undefined ?  '' : escape(this.editedItem.ORGANIZER)
        },{headers:{accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          this.loading = false;
          if(result.data.resultCode == 0){
            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            this.$alert(this.$t('eventinfo_msg17'));
            this.selectFile = null;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eventinfo_msg18'));
          }          
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          this.$alert(this.$t('eventinfo_msg18'));
        });          

      },

      //갤러리 리스트
      gallerylist(){
        this.$http.post(this.$host+'/api/GalleryList',{
              COM_IDX: this.SEARCH_COM_IDX
            , ADMIN_IDX: this.$session.get("ADMIN_IDX")
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            const list = result.data.resultData;
            this.GALLIST.splice(0, this.GALLIST.length);   //데이터 초기화
            list.forEach(element => {
                this.GALLIST.push(element); 
            });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
         
        });
        
      },

      
      mapclick(event){
        //클릭시 마커 위치 설정
        this.marker_position = event.latLng;

      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_COM_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        this.editedItem = {};

      },


      //대표장소 설정
      comareacb(val1){

        

        if(val1.AREANAME.length > 0){
          this.editedItem.AREANAME  = val1.AREANAME;
          this.editedItem.AREA_IDX  = val1.IDX;
          this.editedItem.ADDR1     = val1.ADDR1;
          this.editedItem.ADDR2     = val1.ADDR2;
          this.editedItem.LATITUTE  = val1.LATITUTE;
          this.editedItem.LONGITUTE = val1.LONGITUTE;

          this.map_position    = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
          this.marker_position = JSON.parse('{"lat":'+parseFloat(this.editedItem.LATITUTE)+', "lng":'+parseFloat(this.editedItem.LONGITUTE)+'}');
          
          this.gmap.panTo(this.map_position);
          this.gmarker.setPosition(this.marker_position);

        }else{
          this.editedItem.AREANAME = '';
          this.editedItem.AREA_IDX = null;
          this.editedItem.ADDR1 = "";
          this.editedItem.ADDR2 = "";
        }
      },
      
      //대표장소 취소
      // eslint-disable-next-line no-unused-vars
      comareaclear(var2){
        this.editedItem.AREANAME = '';
        this.editedItem.AREA_IDX = null;
      },


    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

  #gmap{
    width:500px;
    height: 300px;
    background-color: gray;
  }

  div{
    background-repeat:repeat !important;
  }



   
</style>